import {
  GET_WORKORDERS,
  GET_WORKORDERS_SUCCESS,
  GET_WORKORDERS_FAIL,
  ADD_WORKORDER,
  ADD_WORKORDER_SUCCESS,
  ADD_WORKORDER_FAIL,
  UPDATE_WORKORDER,
  UPDATE_WORKORDER_SUCCESS,
  UPDATE_WORKORDER_FAIL,
  DELETE_WORKORDER,
  DELETE_WORKORDER_SUCCESS,
  DELETE_WORKORDER_FAIL,
  SET_WORKORDER_FIELD_ERRORS,
  GET_WORK_ORDER_STATES,
  GET_WORK_ORDER_STATES_SUCCESS,
  GET_WORK_ORDER_STATES_FAIL,
} from './actionTypes'

const initialState = {
  workorders: [],
  workOrderStates: [],
  loading: false,
  statesLoading: false,
  error: null,
  status: null,
  fieldErrors: {}, // Store field-specific errors
  totalCount: 0,
}

const workOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_WORKORDERS:
      return { ...state, loading: true }
    case GET_WORKORDERS_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        workorders: action.payload, 
        totalCount: action.payload?.TotalCount || action.payload?.Data?.length || 0,
        error: null 
      }
    case GET_WORKORDERS_FAIL:
      return { ...state, loading: false, error: action.payload }

    case ADD_WORKORDER:
      return { ...state, loading: true }
    case ADD_WORKORDER_SUCCESS:
      return { ...state, loading: false, status: 'success', fieldErrors: {} }
    case ADD_WORKORDER_FAIL:
      return { ...state, loading: false, error: action.payload }

    case UPDATE_WORKORDER:
      return { ...state, loading: true }
    case UPDATE_WORKORDER_SUCCESS:
      return { ...state, loading: false, fieldErrors: {} }
    case UPDATE_WORKORDER_FAIL:
      return { ...state, loading: false, error: action.payload }

    case DELETE_WORKORDER:
      return { ...state, loading: true }
    case DELETE_WORKORDER_SUCCESS:
      return { ...state, loading: false }
    case DELETE_WORKORDER_FAIL:
      return { ...state, loading: false, error: action.payload }

    case SET_WORKORDER_FIELD_ERRORS:
      return { ...state, fieldErrors: action.payload }

    case GET_WORK_ORDER_STATES:
      return { ...state, statesLoading: true }
    case GET_WORK_ORDER_STATES_SUCCESS:
      return { ...state, statesLoading: false, workOrderStates: action.payload }
    case GET_WORK_ORDER_STATES_FAIL:
      return { ...state, statesLoading: false, error: action.payload }

    default:
      return state
  }
}

export default workOrderReducer
